const development = {
    API_END_POINT: 'https://dev.api.es.genesis.sutoene.co.jp/v1/switching/low',
    API_END_POINT2: 'https://dev.api.es.genesis.sutoene.co.jp/v1/switching/occto/low',
    OKTA_AUTH_MODE: true,
    OKTA_ISSUER_URL: 'https://grandata.okta.com/',
    OKTA_CLIENT_ID: '0oa1fgxlumn690PVs697',
    OKTA_JWT_TYPE: 'client_secret_jwt',
    OKTA_CLIENT_SECRET: '0lPN4bhT2Gl0VPqvXj85uOtAiN2HQ3BaCQs4VFky_WU',
    OKTA_PRIVATE_KEY: '',
    ERROR_MODE    : false,
};
export default development;